/** Datos de la Convocatoria pública que son DUEÑOS del Paso 1 (Datos):
 * pelota oficial y costo. La convocatoria guarda una copia al momento de
 * publicarse; si el admin cambia el dato en Datos después (o publicó la
 * convocatoria antes de llenarlo), esa copia queda vieja. Eduardo 2026-09-10:
 * "en Datos es Head Marathon la pelota" y el link público decía el
 * placeholder "Pelota según etapa/categoría.". Regla: gana el Paso 1; la
 * copia de la convocatoria solo aplica cuando el Paso 1 está vacío, y el
 * placeholder nunca cuenta como valor. */

const BALL_PLACEHOLDERS = new Set(["pelota según etapa/categoría.", "pelota según etapa/categoría", "por definir", "por definir."]);

function clean(value: string | null | undefined): string {
  return (value ?? "").trim();
}

export function publicBallFactValue(options: {
  officialBall: string | null | undefined;
  convocatoriaBalls: string | null | undefined;
}): string | null {
  const official = clean(options.officialBall);
  if (official) return official;
  const copy = clean(options.convocatoriaBalls);
  if (!copy || BALL_PLACEHOLDERS.has(copy.toLowerCase())) return null;
  return copy;
}

export function publicCostFactValue(options: {
  registrationCost: string | null | undefined;
  convocatoriaCost: string | null | undefined;
}): string | null {
  const official = clean(options.registrationCost);
  if (official) return official;
  return clean(options.convocatoriaCost) || null;
}

/** Etiqueta del formato para el hero: manda el formato de las categorías
 * (si todas coinciden); el tipo "ladder" del torneo es el genérico legado y
 * NO significa Escalera salvo que una categoría lo diga. */
export function heroFormatLabel(options: {
  tournamentType: string | null | undefined;
  divisionFormats: Array<string | null | undefined>;
}): string | null {
  const labels: Record<string, string> = {
    round_robin: "Round Robin",
    elimination: "Eliminación directa",
    ladder: "Escalera",
  };
  const formats = new Set(options.divisionFormats.map((value) => clean(value)).filter(Boolean));
  if (formats.size === 1) return labels[[...formats][0]] ?? null;
  if (formats.size > 1) return null;
  const type = clean(options.tournamentType);
  if (type === "ladder") return null;
  return labels[type] ?? null;
}
